{
  "releaseGitCommitHash": "55279f732a5783c7d8429c7d97b48346ca28b246",
  "releaseGitTag": ""
}
